import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWeb3React } from '@web3-react/core';
import { useBestBuyPair, useBestBuyInputAmount, useBestBuyUserConfig } from "../../../../state/dex/hooks";
import { useModalOpened, useModalToggle } from "../../../../state/application/hooks";
import { ApplicationModal } from "../../../../state/application/reducer";
import { useTradeSubmit, useNeedApprove, useTradeVerify, InputAmountStatus, useMinMaxAmountVerify } from "../../hooks";
import styled from 'styled-components';
import IconLock from "../../../../assets/images/lock-white.svg";

var TradeButton = _ref => {
  var text = _ref.text;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 1),
      inputToken = _useBestBuyPair2[0];

  var _useBestBuyInputAmoun = useBestBuyInputAmount(),
      inputAmount = _useBestBuyInputAmoun.inputAmount;

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      expiration = _useBestBuyUserConfig.expiration,
      rate = _useBestBuyUserConfig.rate;

  var _expiration$split = expiration.split('_'),
      _expiration$split2 = _slicedToArray(_expiration$split, 2),
      expirationValue = _expiration$split2[0],
      expirationUnit = _expiration$split2[1];

  var _useState = useState(InputAmountStatus.DEFAULT),
      inputStatus = _useState[0],
      setInputStatus = _useState[1];

  var isPreviewOpen = useModalOpened(ApplicationModal.BEST_BUY_ORDER_PREVIEW);
  var toggleWalletModal = useModalToggle(ApplicationModal.WALLET_CONNECT);
  var togglePreviewModal = useModalToggle(ApplicationModal.BEST_BUY_ORDER_PREVIEW);
  var needApprove = useNeedApprove();
  var submitTrade = useTradeSubmit();
  var verifyTrade = useTradeVerify();
  var verifyMinMaxAmount = useMinMaxAmountVerify();
  var disabledByAmount = useMemo(() => {
    console.log("inputAmount", inputAmount);
    var disabledInputAmount = !inputAmount || isNaN(Number(inputAmount)) || Number(inputAmount) === 0;
    var disabledRate = !rate || isNaN(Number(rate)) || Number(rate) === 0;
    var disabledExpiration = !expirationValue || isNaN(Number(expirationValue)) || Number(expirationValue) === 0;
    return disabledInputAmount || disabledRate || disabledExpiration;
  }, [inputAmount, rate, expirationValue]);
  useEffect(() => {
    if (inputAmount === '') return setInputStatus(InputAmountStatus.DEFAULT);
    var minMaxResult = verifyMinMaxAmount(inputAmount, expirationValue);
    setInputStatus(minMaxResult);
  }, [inputAmount, expirationValue]);
  var disabled = useMemo(() => {
    console.log('inputStatus', inputStatus);

    if (![InputAmountStatus.DEFAULT, InputAmountStatus.VERIFIED].includes(inputStatus)) {
      return true;
    }

    if (!account) {
      return false;
    } else if (!needApprove) {
      return disabledByAmount;
    } else return false;
  }, [account, disabledByAmount, inputStatus]);
  var textLabel = needApprove ? "".concat(t('tokenlon_set_allowance'), " ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol) : text || t('confirm');
  var onSubmit = useCallback(() => {
    if (!account) {
      toggleWalletModal();
      return;
    } else if (isPreviewOpen) {
      if (verifyTrade()) {
        submitTrade();
      }
    } else if (verifyTrade()) {
      togglePreviewModal();
    }
  }, [verifyTrade, submitTrade, isPreviewOpen]);
  return __jsx(StyledTradeButton, {
    disabled: disabled,
    onClick: onSubmit
  }, account ? textLabel : t('connect'), needApprove && __jsx("img", {
    className: "approve-lock",
    src: IconLock,
    alt: "lock"
  }));
};

export default TradeButton;
var StyledTradeButton = styled.button.withConfig({
  displayName: "StyledTradeButton",
  componentId: "sc-151mnct-0"
})(["align-items:center;background:#5f4dbc;border:none;border-radius:48px;color:#ffffff;display:flex;flex-direction:row;font-size:16px;font-weight:500;justify-content:center;letter-spacing:0.533333px;line-height:140%;outline:none;padding:13px 0;text-align:center;width:100%;cursor:pointer;&:disabled{background-color:#beb8e2;cursor:not-allowed;}.approve-lock{margin-left:5px;}"]);